import { useMutation, useQueryClient } from '@tanstack/react-query';
import { client } from '../client';

function unwrapApiResponse(data: any): any {
  if (data && typeof data === 'object' && 'success' in data && 'data' in data) return data.data;
  return data;
}

export const useCreateDocument = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data: any) => client.post('/documents', data).then(r => r.data).then(unwrapApiResponse),
    onSuccess: (_data, variables: any) => {
      qc.invalidateQueries({ queryKey: ['documents', variables?.workspaceId || ''] });
    },
  });
};

export const useUpdateDocument = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }: { id: string; data: any }) => {
      if (!id || id === 'undefined' || id === 'null') {
        throw new Error('Não é possível atualizar um documento sem identificador.');
      }
      return client.put(`/documents/${id}`, data).then(r => r.data).then(unwrapApiResponse);
    },
    onSuccess: (_data, vars) => {
      qc.invalidateQueries({ queryKey: ['documents'] });
      qc.invalidateQueries({ queryKey: ['document', vars.id] });
    },
  });
};

export const useDeleteDocument = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => client.delete(`/documents/${id}`).then(r => r.data).then(unwrapApiResponse),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['documents'] });
    },
  });
};

export const useUploadDocument = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ file, metadata }: { file: File; metadata?: any }) => {
      const formData = new FormData();
      formData.append('file', file);
      if (metadata) formData.append('metadata', JSON.stringify(metadata));
      return client.post('/documents/upload', formData, {
        timeout: 120000,
      }).then(r => r.data).then(unwrapApiResponse);
    },
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['documents'] });
    },
  });
};
